export const envVars: object = {
  "rollbarAccessToken": "0b129fd8e99a4ffea0a42725b8e4dffb"
};